module.exports = __webpack_public_path__ + "media/applicants/device_signup_8-8a6cc6d3.webp";